module.exports = __webpack_public_path__ + "img/switzerland-female.4f7ec333.png";